import { ActivatedRoute, Params, NavigationEnd, Router } from '@angular/router';
import { BuchungService } from './../api/buchung.service';
import { Component, OnInit } from '@angular/core';
import { BuchungResult } from '../api/buchung-result';
import { combineLatest } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { query } from '@angular/animations';

@Component({
  selector: 'app-buchungen',
  templateUrl: './buchungen.component.html',
  styleUrls: ['./buchungen.component.scss']
})
export class BuchungenComponent implements OnInit {
  public buchungResult: BuchungResult;
  public jahr: number;
  public monat: number;

  constructor(public buchungService: BuchungService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.url.pipe(
      withLatestFrom(this.route.paramMap, this.route.queryParamMap)
    ).subscribe(([url, paramMap, queryParamMap]) => {
      let jahr: string = paramMap.get('jahr');
      let monat: string = paramMap.get('monat');
      let kontoId = queryParamMap.get('konto');
      if (!!kontoId) {
        this.buchungService.getBuchungenByKonto(+kontoId).subscribe(
          (buchungResult: BuchungResult) => {
            this.buchungResult = buchungResult;
          }
        )
      }
      else if (!!jahr && !!monat) {
        this.jahr = +jahr;
        this.monat = +monat;
        this.loadBuchungen();
      }
      else {
        this.jahr = 2020;
        this.monat = 1;
        this.loadBuchungen();
      }
    });
  }

  private loadBuchungen(): void {
    this.buchungService.getBuchungen(this.jahr, this.monat).subscribe(
      (buchungResult: BuchungResult) => {
        this.buchungResult = buchungResult;
      }
    )
  }

  public onClickBack(): void {
    if (this.monat === 1) {
      this.monat = 12;
      this.jahr--;
    }
    else {
      this.monat--;
    }
    this.router.navigate(['/buchungen/' + this.jahr + '/' + this.monat]);
  }

  public onClickForward(): void {
    if (this.monat === 12) {
      this.monat = 1;
      this.jahr++;
    }
    else {
      this.monat++;
    }
    this.router.navigate(['/buchungen/' + this.jahr + '/' + this.monat]);
  }
}
